import { IncodeSMSContainer } from "@containers/common/properties-sections/incode-sms-container/incode-sms-container"
import { PageLevelTypes } from "@enums/page-level-types";
import { AxnDocumentationLink } from "@idw-types/data/reference-data/axn";
import { FormattedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";

type WorkflowIncodeSmsContainerProps = {
    isDisabled: boolean;
    documentationLinks: Array<AxnDocumentationLink>;
    workflowDetailsConfigurationState: FormattedWorkflowDetailsConfiguration;
    updateProperties: (properties: Array<{
        propertyTypeId: string;
        newValue: string;
        added: boolean;
    }>) => void;
    incodeSmsMessagingServiceError: React.ReactNode;
}

export const WorkflowIncodeSmsContainer = (props: WorkflowIncodeSmsContainerProps) => {
    const { isDisabled, documentationLinks, workflowDetailsConfigurationState, incodeSmsMessagingServiceError, updateProperties } = props;

    return (<IncodeSMSContainer
        isDisabled={isDisabled}
        documentationLinks={documentationLinks}
        pageLevel={PageLevelTypes.WORKFLOW}
        appliedProfiles={workflowDetailsConfigurationState.appliedProfiles}
        properties={[]}
        workflowId={workflowDetailsConfigurationState.id}
        canModifyNonRestrictedProperties={workflowDetailsConfigurationState.permissions.canModifyNonRestrictedProperties}
        incodeSmsMessagingServiceError={incodeSmsMessagingServiceError}
        updateProperties={updateProperties}
    />);
}